import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Skeleton from "@mui/material/Skeleton";
import { COMPACT_QUERY } from "../../../utils/hooks/useCompact";

const compact = "@media " + COMPACT_QUERY;

export default function WasteTableSkeleton() {
  const rows = Array.from({ length: 10 });
  const columns = Array.from({ length: 5 });

  return (
    <Paper sx={{ height: "623px", [compact]: { height: "440px" }, overflowY: "auto" }}>
      <TableContainer>
        <Table>
          <TableBody>
            {rows.map((_, rowIndex) => (
              <TableRow key={rowIndex}>
                {columns.map((_, colIndex) => (
                  <TableCell key={colIndex}>
                    <Skeleton
                      variant="rectangular"
                      height={28}
                      sx={{
                        borderRadius: 1,
                        bgcolor: "rgba(0,0,0,0.05)",
                      }}
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
